import React from 'react' 
import { Button, Dialog,DialogActions, DialogContent, DialogTitle, Typography } from '../ui/core';
import List from '../users/list';
export default function QuickSearch({title,items,onClick,onClose}) {

    return (
        <Dialog onClose={onClose} fullScreen>
            <DialogTitle><Typography component="h2">{title || 'Zoeken medewerkers'}</Typography></DialogTitle>
            <DialogContent>
                <List items={items} onClick={onClick}/>
            </DialogContent>
            <DialogActions>
                 <Button onClick={onClose}>SLUITEN</Button>
            </DialogActions>
        </Dialog>
    )
}
